export default __webpack_public_path__ + "static/media/bz-check-1.1e83077c.webp";